<template>
<div>
    <slot></slot>
    <div :class="['error-div', Boolean(validationMessageStyle) ? validationMessageStyle : '']" >
        {{validationMessage}}
    </div>
</div>
</template>

<script>
import primitiveMixin from './primitive-mixin'
import { v } from "framework";

export default {
    mixins: [primitiveMixin],
    props: {
        validationMessageStyle: {
            type: String,
            default: null
        },
    },
    data() {
        return {
            
        }
    },
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/framework/primitives/AmfValidationWrapper.vue